module.exports = __webpack_public_path__ + "static/media/1023477.0d920b59.png";